import { createReducer } from 'typesafe-actions';
import { projects } from './actions';
import { GetProjectsResponse } from './types';
import { RequestStatus } from 'utils/types';

type State = {
  data: GetProjectsResponse[] | null;
  message: string | null;
  status: RequestStatus | null;
};

const initialState: State = {
  data: null,
  message: null,
  status: null,
};

const projectsReducer = createReducer(initialState)
  .handleAction(projects.request, (state) => ({
    ...state,
    data: null,
    message: null,
    status: RequestStatus.PENDING,
  }))
  .handleAction(projects.success, (state, action) => ({
    ...state,
    data: [
      ...action.payload,
    ],
    message: null,
    status: RequestStatus.SUCCESS,
  }))
  .handleAction(projects.failure, (state, action) => ({
    ...state,
    data: null,
    message: action.payload.message,
    status: RequestStatus.FAILED,
  }));

export default projectsReducer;
